export const ColorsMove = {
  primary: '#0CE865',
  primaryDarker: '#01EA6B',
  primaryLight: '#fbebe9',
  primaryLighter: '#fdf5f4',
  primaryMove: '#0CE865',
  secondaryMove: '#023C40',
  lightGreenMove: '#E8F2EC',
  tertiaryRedMove: '#C82828',

  primaryWhite: '#ffffff',
  primaryTextColor: '#023c40',

  secondary: '#023c40',
  secondaryDarker: '#4448a0',
  secondaryLighter: '#ededf6',

  secondaryBlue: '#4b4fa6',

  tertiary: '#8D1414',
  tertiaryGreen: '#067e41',
  tertiaryHunterGreen: '#157B3E',
  tertiaryGreenDarker: '#036835',
  tertiaryGreenLighter: '#e6f2ec',

  tertiaryOrange: '#c94318',
  tertiaryOrangeDarker: '#b73810',
  tertiaryOrangeLighter: '#faece8',

  tertiaryBlue: '#2f73d2',
  tertiaryBlueDarker: '#2765bd',
  tertiaryBlueLighter: '#eaf1fb',

  darkBlack: '#212124',
  greyDarker: '#4c4c50',
  greyDark: '#75767A',
  charcoalGrey: '#2C2B2F',

  grey: '#c5c9d0',
  greyLight: '#d9dbe0',
  greyLighter: '#f8f8f8',

  starRatedColor: '#FFC226',
  starEmptyColor: '#C5C9D0',

  greenDark: '#067E41',
  primaryRed: '#dc3224',
  crimsonRed: '#AD1C29',

  quaternary: '#023c40',
  quinary: '#e8f2ec',
};

const fontSizes = [12, 14, 16, 20, 24, 40];
const space = [0, 2, 4, 8, 16, 24, 32, 40, 48];
const breakpoints = ['840px', '1440px'];
const borderRadius = {
  small: '3px',
  normal: '4px',
  Xnormal: '8px',
  medium: '16px',
  large: '40px',
  XLarge: '50px',
};
const containerMaxWidth = 1224;
const fontFamily = 'DM Sans';
const shadows = {
  lightTop: '0px -2px 6px rgba(0, 0, 0, 0.04)',
};
const backgroundColor = {
  black: '#000000',
  blue: '#4B4FA6',
  blueActive: '#D9EFFF',
  blueLight: '#EAF1FB',
  default: '#FFFFFF',
  green: '#067E41',
  greenLight: '#E6F2EC',
  greyDarker: '#4C4C50',
  greyLight: '#EFEFEF',
  greyLighter: '#F8F8F8',
  greyLine: '#c4c4c4',
  lightBlue: '#074fa6',
  offWhite: '#ECEDEF',
  oldLace: '#FFF4E5',
  pink: '#B04459',
  pinkLight: '#FAEAEA',
  primary: '#F8F8F8',
  redLight: '#FBEBE9',
  secondary: '#212124',
  secondaryBlue: '#4B4FA6',
  secondaryLight: '#EDEDF6',
  tertiary: '#C5C9D0',
  yellowLight: '#FFF4E6',
};
const fontWeight = {
  bold: 500,
  large: 700,
  medium: 500,
  normal: 400,
  semiLarge: 600,
};
const lineHeight = {
  XLarge: '24px',
  XSmall: '14px',
  XXLarge: '28px',
  XXSmall: '16px',
  large: '22px',
  normal: '20px',
  semiLarge: '21px',
  semiSmall: '12px',
  small: '18px',
  titleLarge: '72px',
  titleMedium: '48px',
  titleNormal: '36px',
  titleSmall: '30px',
};

export const getColorSchema = ({
  primary,
  secondary,
  tertiary,
  icon,
  schema,
}) => {
  if (!schema) {
    return {};
  }
  if (primary) {
    return schema.primary;
  }
  if (secondary) {
    return schema.secondary;
  }
  if (tertiary) {
    if (icon) {
      return schema.tertiaryIcon;
    }
    return schema.tertiary;
  }
  return schema.primary;
};
const padding = {
  XSmall: '2px',
  small: '4px',
  semiSmall: '6px',
  normal: '8px',
  semiLarge: '10px',
  large: '12px',
  XLarge: '16px',
  XXLarge: '18px',
};

const margin = {
  XSmall: '2px',
  small: '4px',
  semiSmall: '6px',
  normal: '8px',
  semiLarge: '10px',
  large: '12px',
  XLarge: '16px',
  XXLarge: '18px',
};

export default {
  borderRadius,
  breakpoints,
  backgroundColor,
  space,
  fontSizes,
  colors: ColorsMove,
  containerMaxWidth,
  fontFamily,
  fontWeight,
  shadows,
  lineHeight,
  padding,
  margin,
};
